// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { TextField } from "@hex-insights/forms";
import { StudentMedicationNoteFormValues } from "../../FormUtilities";
import { BaseFieldProps } from "../shared";
import { StudentNoteSelectField } from "../StudentNote";

/**
 * Generic props for fields of the StudentMedicationNote model.
 */
type FieldProps<K extends keyof StudentMedicationNoteFormValues.Base = keyof StudentMedicationNoteFormValues.Base> =
	BaseFieldProps<Pick<StudentMedicationNoteFormValues.Base, K>>;

/**
 * Field component for the `body` field of the StudentMedicationNote model.
 */
export function Body({ formState, ...props }: FieldProps<"body">) {
	return <TextField formState={formState} name="body" multiLine optional {...props} />;
}

export namespace StudentNote {
	export type SelectProps = FieldProps<"studentNoteID"> &
		Omit<StudentNoteSelectField.SelectProps<StudentMedicationNoteFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `studentNote` edge of the StudentMedicationNote model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <StudentNoteSelectField.Select formState={formState} name="studentNoteID" {...props} />;
	}
}
